export { HeaderValuePickerStyled as default } from './styled'
